import React from 'react';

import DesktopView from './desktop';
import MobileView from './mobile';
import {DeviceSize, useDeviceSize} from '../../../../../../shared/theme/helpers';
import {ViewProps} from './model';

export default ({requests}: ViewProps) => {
  const deviseSize = useDeviceSize();
  return deviseSize === DeviceSize.desktop ? <DesktopView requests={requests} /> : <MobileView requests={requests} />;
};
